module.exports = __webpack_public_path__ + "img/icon_play.eb25be89.svg";